import React from 'react';
import { motion } from 'framer-motion';
import ContactForm from '../components/ContactFormElevated';
import ParallaxBackground from '../components/ParallaxBackground';

const Landlords = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="min-h-screen"
    >
      <ParallaxBackground 
        image="/images/boathouse-row.jpg"
        className="py-32"
        overlay={true}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 text-white">
            Landlords and Property Owners
          </h1>
          <p className="text-xl md:text-2xl text-gray-200 max-w-3xl mx-auto">
            Specialized closing services for property owners and landlords
          </p>
        </div>
      </ParallaxBackground>

      <section className="py-16 bg-eagle-light-gray">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-eagle-dark mb-4">
              Landlords and Property Owners Services
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              As a landlord or property owner, ensuring a smooth and efficient closing process is essential for successful property management. At Eagle Closing, we offer specialized closing services tailored specifically to the needs of landlords and property owners. Our experienced team is dedicated to providing a seamless and hassle-free experience for you.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                title: 'Efficient Lease and Rental Agreement Review',
                description: 'Our professionals meticulously review lease and rental agreements, ensuring that all terms and conditions are accurately reflected and in compliance with local laws. We help protect your interests and ensure a smooth transition for both you and your tenants.',
              },
              {
                title: 'Document Preparation and Review',
                description: 'We handle the preparation and review of all necessary closing documents, including rental agreements, lease renewals, and termination documents. Our attention to detail ensures accuracy and compliance with legal requirements.',
              },
              {
                title: 'Title Examination and Insurance',
                description: 'We conduct thorough title examinations to ensure the property has a clear title, free from any liens or claims that could impact your ownership or rental activities. Additionally, we assist in obtaining title insurance, providing protection and peace of mind regarding the property\'s ownership.',
              },
              {
                title: 'Coordination with Tenants and Service Providers',
                description: 'We act as a central point of contact, facilitating communication between you, your tenants, and service providers involved in the closing process. We ensure that all parties are informed and work together smoothly.',
              },
              {
                title: 'Timely and Efficient Closings',
                description: 'We understand the importance of timely closings to minimize disruptions to your rental operations. Our streamlined processes and commitment to efficiency help ensure that closings are conducted promptly and efficiently.',
              },
            ].map((service, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow"
              >
                <h3 className="text-xl font-semibold text-eagle-dark mb-3">
                  {service.title}
                </h3>
                <p className="text-gray-600">
                  {service.description}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <p className="text-lg text-gray-700 mb-8">
              At Eagle Closing, we prioritize professionalism, integrity, and efficiency in every closing we handle for landlords and property owners. We strive to make the closing process as seamless as possible, allowing you to focus on managing your properties effectively.
            </p>
            <p className="text-lg text-gray-700 mb-8">
              Contact us today to learn more about our services for landlords and property owners and how we can assist you in achieving a successful and hassle-free closing. Trust Eagle Closing to be your dedicated partner throughout your real estate journey, ensuring a smooth transition and peace of mind for your rental properties.
            </p>
          </div>
        </div>
      </section>
      
      {/* Contact Form with Parallax */}
      <ContactForm backgroundImage="/images/benjamin-franklin-bridge.jpg" />
    </motion.div>
  );
};

export default Landlords;

